import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { PagedDataResponse, PagedDataRequest } from 'src/app/stp/stp-app/api-client';

type GetPagedDataFunction<T> = (pagedDataRequest: PagedDataRequest) => Observable<PagedDataResponse<T>>;

export class DataTableSource<T> implements DataSource<T> {

  private dataSubject = new BehaviorSubject<T[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private getPagedData: GetPagedDataFunction<T>;
  private _length = 0;
  private _errored = false;

  public loadingChange = this.loadingSubject.asObservable();

  constructor(getPagedData: GetPagedDataFunction<T>) {
    this.getPagedData = getPagedData;
  }

  get dataLength(): number {
    return this._length;
  }

  get loading(): boolean {
    return this.loadingSubject.value;
  }

  get errored(): boolean  {
    return this._errored;
  }

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  load(pagedDataRequest: PagedDataRequest) {
      this.loadingSubject.next(true);
      this._errored = false;

      this.getPagedData(pagedDataRequest).pipe(
          tap((pagedDataResponse: PagedDataResponse<T>) => {
            this.validateResponse(pagedDataResponse);
            this._length = pagedDataResponse.total;
          }),
          catchError((error) => {
            this._errored = true;
            console.error(error);
            return of(<PagedDataResponse<T>>{data: [], total: 0});
          }),
          finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(pagedData => this.dataSubject.next(pagedData.data));
  }

  validateResponse(pagedDataResponse: PagedDataResponse<T>) {
    if (pagedDataResponse.total === undefined || !pagedDataResponse.data) {
      throw new Error('API data format incorrect.');
    }
  }
}
